import React from 'react'
import {TotalProps} from '.'

export const Total: React.FC<TotalProps> = ({total, t}) => (
  <div data-hook="total" role="cell" aria-label={`${t('ticketsPicker.subtotal')}: ${total}`}>
    {total}
  </div>
)
